import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { colors } from '../styles/colors.ts';

const ScrollButton = styled.button`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  background-color: ${(colors.white)};
  border: solid 1px ${(colors.neutral[200])};
  color: ${(colors.black)};
  min-width: 40px;
  height: 40px;
  border-radius: 10rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0 1rem;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  z-index: 1000;

  &:hover {
    background-color: ${(colors.neutral[100])};
  }

  &.visible {
    opacity: 1;
  }

  & span {
    font-size: 0.6rem;
    font-weight: 600;
  }
`;

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ScrollButton 
      onClick={scrollToTop}
      className={isVisible ? 'visible' : ''}
      aria-label="Scroll to top"
    >
        <span>Back to top</span>
      ↑
    </ScrollButton>
  );
};

export default ScrollToTop;
